import { defineMessages, type IntlShape } from 'react-intl';
import type { BlockConfigBase, JSONSchema } from '@plone/types';

export interface Ross1000StruttureData {
  '@type': 'ross1000strutture';
}

const schema = ({
  data,
  intl,
}: {
  data: Ross1000StruttureData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: intl.formatMessage(messages.ross1000strutture_title),
    fieldsets: [],
    properties: {},
    required: [],
  };

  return schema;
};

export default schema;

export interface ross1000struttureConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof schema;
}

const messages = defineMessages({
  ross1000strutture_title: {
    id: 'ross1000strutture_title',
    defaultMessage: 'Ricerca strutture Ross1000',
  },
});
